import { IntakeLabelCollection } from '../../entities/intake-label.interface';

export const AishRelationLabels: IntakeLabelCollection = {
  relationship: {
    label: 'What is your relationship to the applicant?',
    onBehalfLabel: 'What is your relationship to <<oboName>>?',
  },
  hasLegalAuthority: {
    label: `Do you have a legal document that gives you formal authority to act on the applicant's behalf?`,
    onBehalfLabel: `Do you have a legal document that gives you formal authority to act on <<oboName>>'s behalf?`,
  },
  legalAuthorityNote: {
    label:
      'If you select yes, you need to provide a document confirming you are the Trustee or have Power of Attorney for the person you are applying for.',
  },
  legalGuardianshipYes: { label: 'Yes - I have Legal Guardianship or a Trusteeship order' },
  powerOfAttorneyYes: { label: 'Yes - I have Power of Attorney or a Trusteeship Order' },
  legalAuthorityNo: { label: 'No' },
  canUnderstandAndSign: {
    label: 'Can the applicant understand and sign the application themselves?',
    onBehalfLabel: 'Can <<oboName>> understand and sign the application themselves?',
  },
  yes: { label: 'Yes' },
  no: { label: 'No' },
  contactPerson: { label: 'Who should we contact about this application?' },
  contactSection: { label: 'Contact information' },
  prefilledLockedHeading: { label: 'Prefilled and locked information' },
  prefilledHeading: { label: 'Prefilled information' },
  verifiedAccountInfo: {
    label:
      'Some of the fields below are completed for you and locked because we received this information from your verified Alberta.ca Account.',
  },
  basicAccountInfo: {
    label:
      'Some of the fields below are completed for you because we received this information from your Alberta.ca Account.',
  },
  verifiedInfoHeading: { label: 'Verified Information' },
  firstName: { label: 'First name' },
  preferredName: { label: 'Preferred name, if different' },
  lastName: { label: 'Last name' },
  organizationName: { label: 'Organization name' },
  roleInOrganization: { label: 'Role in the organization' },
  phoneNumbers: { label: 'Phone number' },
  email: { label: 'Email address' },
  // documents: { label: 'Trustee/Power of Attorney documents' },
  // documentsUnder18: { label: 'Legal Guardian/Trustee documents' },
};
